<template>
  <span>{{ formattedValue }}</span>
</template>

<script>
import { isToday } from 'date-fns';
import { format } from '../date-utils';

export default {
  name: 'AppDateFormatted',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedValue() {
      const date = new Date(this.value);
      return isToday(date)
        ? `${this.$t('today')} ${format(date, 'HH:mm')}`
        : `${format(date, 'd MMMM')}`;
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  today: Today at
</i18n>

<i18n locale="ru" lang="yaml">
  today: Сегодня в
</i18n>
